import React from 'react';

const chevronIcon = 
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 14">
    <title>chevron-right</title>
    <path d="M10.87,6.51l-6-6a1,1,0,0,0-1.4,0,1,1,0,0,0,0,1.4l5.3,5.3-5.3,5.3a1,1,0,0,0,0,1.4.91.91,0,0,0,.7.3.91.91,0,0,0,.7-.3l6-6A1,1,0,0,0,10.87,6.51Z" transform="translate(-3.17 -0.21)"/>
  </svg>

export default chevronIcon;
